import { z } from "zod";

import { assetSchema } from "./asset";
import { productSchema } from "./product";

export const assetSearchOutputSchema = z.object({
  assets: z
    .array(
      assetSchema.pick({
        name: true,
        url: true,
        type: true,
        width: true,
        height: true,
        embeddingText: true,
      }),
    )
    .optional(),
});

export const editOutputSchema = z.object({
  editResult: z.string(),
});

export const staticAnalysisOutputSchema = z.object({
  staticAnalysisResult: z.string(),
});

export const completeTaskOutputSchema = z.object({
  updatedPlan: z.string(),
  nextTask: z.string(),
});

export const readOutputSchema = z.object({
  content: z.string(),
});

export const lsOutputSchema = z.object({
  entries: z.string(),
});

export const productSearchOutputSchema = z.object({
  products: z.array(
    productSchema.pick({
      title: true,
      id: true,
      description: true,
    }),
  ),
});
